import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export function Tag({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border border-border/70 bg-background/65 px-2.5 py-1 text-xs font-semibold text-muted-foreground",
        className,
      )}
    >
      {children}
    </span>
  )
}
